export default {
  region: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_k9fMf9fsd',
  cognitoUserPoolWebClientId: '5qn3v33mojt8biespb3unk7n17',
  cognitoIdentityPoolId: 'us-east-1:5bde0a2a-2e17-44a8-baec-e9d4e261b025',
  cognitoDomain: 'pv-mme-dynamic-ads-kentzhan.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://kentzhan.personal.dynamic-ads.video.amazon.dev/auth-callback',
  redirectSignOut: 'https://kentzhan.personal.dynamic-ads.video.amazon.dev/',
  apiServerBaseUrl: 'https://api.kentzhan.personal.dynamic-ads.video.amazon.dev',
  stage: 'personal',
  benderApiServerBaseUrl: 'https://api.beta.bender.dynamic-ads.video.amazon.dev',
  fryApiServerBaseUrl: 'https://api.beta.fry.dynamic-ads.video.amazon.dev',
  loggerBaseUrl: 'https://logger.kentzhan.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  monitoringBaseUrl: 'https://monitoring.kentzhan.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  featureFlags: 'enableReportingDashboard,enableBlocklist,enableAbTesting,enableSpotlightLal,enablePublisherConfigs,enablePublisherConfigCampaignForm',
  spotlightApiGatewayBaseUrl: 'https://beta.spotlight.video.amazon.dev',
  productsBucketName: '',
  mediaBucketName: 'leela-media-804516735644-us-east-1-personal',
  agentCoreWsUrl: 'wss://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn:aws:bedrock-agentcore:us-east-1:804516735644:runtime/leela_agent_orchestrator_personal-EPJechHN9p/ws',
};
